import { Grid } from '@mui/material';
import { STATES_DECLARATIONS } from 'civil-status/constants/states-declarations';
import { memo, useMemo } from 'react';
import { PmiButton } from 'shell/components/shared/button';

interface ActionsFormProps {
  state?: string;
  numberTwins?: number;
  goBack: () => void;
  onClickInsertEvent: () => void;
  onClickCancel: () => void;
  isRejectionState?: boolean;
}

const ActionsFormComponent = ({
  state,
  numberTwins = 0,
  goBack,
  onClickInsertEvent,
  onClickCancel,
  isRejectionState = false,
}: ActionsFormProps): React.ReactElement => {
  const disabledInsertEvent: boolean = useMemo(() => {
    if (numberTwins > 1) {
      return state !== STATES_DECLARATIONS.BOZZA;
    }

    return (
      !(state === STATES_DECLARATIONS.ATTESA_STESURA || state === STATES_DECLARATIONS.BOZZA) ||
      isRejectionState
    );
  }, [state, isRejectionState, numberTwins]);

  return (
    <Grid item xs={12} display="flex" justifyContent="center">
      <PmiButton
        color="cdmBrand"
        variant="outlined"
        onClick={goBack}
        style={{ marginRight: '1rem' }}
      >
        Indietro
      </PmiButton>
      <PmiButton
        color="cdmBrandThird"
        variant="outlined"
        onClick={onClickInsertEvent}
        style={{ marginRight: '1rem' }}
        disabled={disabledInsertEvent}
      >
        {state === STATES_DECLARATIONS.BOZZA ? 'Modifica evento' : 'Inserisci evento'}
      </PmiButton>
      <PmiButton
        color="cdmBrand"
        variant="outlined"
        onClick={onClickCancel}
        style={{ marginRight: '1rem' }}
        disabled={
          !(state === STATES_DECLARATIONS.ATTESA_STESURA || state === STATES_DECLARATIONS.BOZZA) ||
          isRejectionState
        }
      >
        Rifiuta evento
      </PmiButton>
      <PmiButton
        color="cdmBrandThird"
        variant="outlined"
        type="submit"
        disabled={!isRejectionState}
      >
        Salva
      </PmiButton>
    </Grid>
  );
};

ActionsFormComponent.displayName = 'Actions Form Component';

const ActionsForm = memo(ActionsFormComponent);

export default ActionsForm;
